export default __webpack_public_path__ + "static/media/facebook.b3fecb3e.svg";